import AboutHeader from './Header.vue';
import AboutContent from './Content.vue';
import WebsiteFooter from '../WebsiteFooter.vue';

export default {
  name: 'About',
  components: { WebsiteFooter, AboutContent, AboutHeader },
  data: () => ({}),
};
